import { useRef } from 'react';

import { Icon } from '#/components/Icon/Icon';
import { useTrackLinks } from '#/hooks/useTrackLinks';
import { ListingRichText } from '#/modules/listing/components/RichText/ListingRichText';

import {
  ListingRichTextTruncatedHolder,
  listingRichTextTruncatedMaxHeightVar,
  ListingRichTextTruncatedToggleLabel,
} from './ListingRichTextTruncated.styled';

export const listingRichTextTruncateAtAbout2Lines = 56;
export const listingRichTextTruncateAtAbout8Lines = 224;

type Props = {
  html: string;
  truncateAtHeight: number | null;
  eventName?: string;
  eventProperties?: Record<string, unknown>;
  onLinkClick?: (link: HTMLAnchorElement) => void;
  toggleQAId?: string;
  onToggle?: (isOpen: boolean) => void;
  showMoreLinkTitle: string;
  showLessLinkTitle: string;
};

export function ListingRichTextTruncated({
  html,
  truncateAtHeight,
  eventName,
  eventProperties,
  onLinkClick,
  toggleQAId,
  onToggle,
  showMoreLinkTitle,
  showLessLinkTitle,
}: Props) {
  const ref = useRef<HTMLDivElement>(null);

  useTrackLinks({
    ref,
    eventName,
    eventProperties,
    onClick: onLinkClick,
  });

  return (
    <div ref={ref}>
      <ListingRichTextTruncatedHolder
        style={{
          [listingRichTextTruncatedMaxHeightVar]: `${truncateAtHeight}px`,
        }}
      >
        <ListingRichText content={html} />
      </ListingRichTextTruncatedHolder>

      {truncateAtHeight !== null && (
        <ListingRichTextTruncatedToggleLabel data-qa-id={toggleQAId}>
          <span className="show-more">
            {showMoreLinkTitle}
            <Icon name="chevron-down" size={16} />
          </span>

          <span className="show-less">
            {showLessLinkTitle}
            <Icon name="chevron-up" size={16} />
          </span>

          <input
            type="checkbox"
            onChange={
              onToggle ? (event) => onToggle(event.target.checked) : undefined
            }
          />
        </ListingRichTextTruncatedToggleLabel>
      )}
    </div>
  );
}
